import { render, staticRenderFns } from "./DeviceTemperature.vue?vue&type=template&id=c80e0708&scoped=true&"
import script from "./DeviceTemperature.vue?vue&type=script&lang=js&"
export * from "./DeviceTemperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80e0708",
  null
  
)

export default component.exports